import { createFeatureSelector, createSelector } from '@ngrx/store';
import {filterFeatureKey, FilterState} from "../reducers/filter.reducer";

export const selectFilterFeature = createFeatureSelector<FilterState>(
  filterFeatureKey
);

export const getFilterByKey = (key: string) => createSelector(
  selectFilterFeature,
  (state: FilterState) => {

    if(key === 'allProfession') {
      return {
        educationPaths: state.educationPaths,
        selectedRequirements: state.selectedRequirements,
        selectedSchoolSubjectIds: state.selectedSchoolSubjectIds,
        professionsWithStories: state.professionsWithStories,
        selectedInterestFields: state.selectedInterestFields,
      }
    } else if(key === 'allProvider') {
      return {
        selectedProviderTypes: state.selectedProviderTypes,
        selectedInterestFields: state.selectedProviderInterestFields,
        selectedProviderOffers: state.selectedProviderOffers,
        providersWithQuiz: state.providersWithQuiz,
        providersComplete: state.providersComplete,
        activeDistrictIds: state.activeProviderDistrictIds,
        providersDistance: state.providersDistance
      }
    } else if(key === 'allJob') {
      return {
        selectedInterestFields: state.selectedJobInterestFields,
        selectedOfferTypes: state.selectedOfferTypes,
        jobsApprenticeshipMaturaOnly: state.jobsApprenticeshipMaturaOnly,
        jobsPartialQualificationOnly: state.jobsPartialQualificationOnly,
        activeDistrictIds: state.activeJobDistrictIds,
        providersDistance: state.jobsDistance
      }

    } else if(key === 'allRookie') {
      return {
        searchTermRookie: state.searchTermRookie,
        selectedRookieInterestFields: state.selectedRookieInterestFields
      }
    } else if (key !== '' && state.hasOwnProperty(key)) {
      // @ts-ignore
      return state[key]
    }

    return false;
  }
);
export const getAllFiltersByEntity = (key: string) => createSelector(
  selectFilterFeature,
  (state: FilterState) => {

    if(key === 'allProfession') {
      return {
        educationPaths: state.educationPaths,
        selectedRequirements: state.selectedRequirements,
        selectedSchoolSubjectIds: state.selectedSchoolSubjectIds,
        professionsWithStories: state.professionsWithStories,
      }
    } else if(key === 'allProvider') {
      return {

      }
    } else if(key === 'allJob') {
      return {
      }
    }

    return false;
  }
);

export const getFilteredProfessionsNumber = () => createSelector(
  selectFilterFeature,
  (state: FilterState) => state.filteredProfessionsNumber
);

export const getFilteredProvidersNumber = () => createSelector(
  selectFilterFeature,
  (state: FilterState) => state.filteredProvidersNumber
);

export const getFilteredJobsNumber = () => createSelector(
  selectFilterFeature,
  (state: FilterState) => state.filteredJobsNumber
);

export const getFilteredRookieNumber = () => createSelector(
  selectFilterFeature,
  (state: FilterState) => state.filteredRookieNumber
);

export const getJobsFilterState = createSelector(
  selectFilterFeature,
  (state: FilterState) => state
);

export const getUpdateArchiveView = createSelector(
  selectFilterFeature,
  (state: FilterState) => state.updateArchiveView
);

